import { Axios } from '@utils';

// 新用户注册
export const userInfoWebRegister = (params = {}) => {
    return Axios('/user-info-web/register', 'post', params);
};